import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ModeProvider } from './contexts/ModeContext.tsx'
import { BusinessConfigProvider } from './contexts/BusinessConfigContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ModeProvider>
      <BusinessConfigProvider>
        <App />
      </BusinessConfigProvider>
    </ModeProvider>
  </StrictMode>,
)